/**
 * Auth Layout Component
 * Layout for authentication pages (login, register, etc.)
 */

import { Outlet } from 'react-router';

interface AuthLayoutProps {
  /** Subtitle shown under the Kim AI heading. Overridable per auth route. */
  subtitle?: string;
}

export default function AuthLayout({ subtitle = 'Welcome back! Please login to continue.' }: AuthLayoutProps) {
  return (
    <div className='min-h-screen flex items-center justify-center bg-background p-4'>
      <div className='w-full max-w-md'>
        <div className='mb-8 text-center'>
          <img src='/assets/brand/kim-ai-logo.svg' alt='Kim AI' className='h-12 mx-auto mb-4' />
          <h1 className='text-2xl font-bold text-foreground'>Kim AI</h1>
          <p className='text-muted-foreground mt-2'>{subtitle}</p>
        </div>

        <div className='bg-card border border-border rounded-lg shadow-sm p-8'>
          <Outlet />
        </div>

        <div className='mt-6 text-center text-sm text-muted-foreground'>
          <p>&copy; {new Date().getFullYear()} Kim AI. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
